import DocViewShell from "@/components/DocViewShell";
import AssetLifecycleBlueprint from "@/components/blueprints/AssetLifecycleBlueprint";

export default function AssetLifecycleView() {
  return (
    <DocViewShell
      eyebrow="Asset Lifecycle Matrix"
      eyebrowClass="text-blue-700"
      toolName="Asset Lifecycle Matrix"
      maxWidth="max-w-5xl"
      editPathFn={(id) => `/lifecycle/${id}`}
      render={(doc) => <AssetLifecycleBlueprint doc={doc} />}
    />
  );
}
